import React, { Component } from "react";
import { searchComposer } from "ReactReducers/Search/search-composer";
import { productListComposer } from "ReactReducers/ProductList/product-list-composer";
import ProductListComponent from "ReactComponents/ProductList/product-list-component";

class ProductSearchResults extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const noSearchResults = !this.props.TotalResults && this.props.FacetGroupsActive.length == 0;
        return (
            <div className="searchpage-results__products">
                <ProductListComponent
                    noSearchResults={noSearchResults}
                    noSearchResultsText={this.props.emptyProductsText}
                    ProductDeliveryInfo={this.props.ProductDeliveryInfo}
                />
            </div>
        );
    }
}
export default searchComposer(productListComposer(ProductSearchResults));
